import React, { useContext } from "react";
import { LabelContext } from "../../assets/js/labelDataContext";
import DietData from "../../assets/js/dietData";

const OrderDietOption = (props) => {
  const val = useContext(LabelContext);
  const dietOption = val.labelInfo.dietOption;
  const btnDisabled = dietOption.length > 0
  return (
    <form>

      <div className="diet-box">
        <h4>Wybierz wariant</h4>

        {DietData[val.labelInfo.diet].prices.map((option, index) => (
          <div key={index}>
            <input
              id={`option-${index}`}
              type="radio"
              name="dietOption"
              value={index}
              onChange={val.handleChange("dietOption")}
            >
            </input>
            <label
              className={`diet-option ${dietOption == index ? "is-active" : ""}`}
              htmlFor={`option-${index}`}
            >
              {option.option} kcal
            </label>
          </div>
        ))}

        {/* <input
          id="option1200"
          type="radio"
          name="dietOption"
          value="1"
          onChange={val.handleChange("dietOption")}
        >
        </input>
        <label
          className={`diet-option ${dietOption == 1 ? "is-active" : ""}`}
          htmlFor="option1200"
        >
          1200 kcal
        </label>

        <input
          id="option1500"
          type="radio"
          name="dietOption"
          value="2"
          onChange={val.handleChange("dietOption")}
        >
        </input>
        <label
          className={`diet-option ${dietOption == 2 ? "is-active" : ""}`}
          htmlFor="option1500"
        >
          1500 kcal
        </label>

        <input
          id="option2000"
          type="radio"
          name="dietOption"
          value="3"
          onChange={val.handleChange("dietOption")}
        >
        </input>
        <label
          className={`diet-option ${dietOption == 3 ? "is-active" : ""}`}
          htmlFor="option2000"
        >
          2000 kcal
        </label> */}



        <div
          variant="contained"
          color="primary"
          aria-label="text primary button group"
          style={{ marginTop: 15 }}
        >
          <button onClick={() => val.prevPage()}
            className="btn-next">
            Wstecz
          </button>
          <button
            disabled={!btnDisabled}
            onClick={() => val.nextPage()}
            className="btn-next"
          >
            Dalej
          </button>
        </div>
      </div>
    </form>
  );
};
export default OrderDietOption;

